import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { SupportedLanguages } from '@doordash/lib-i18n'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import i18n, { supportedLanguages } from '../../../i18n/'

import { GlobeIcon, LanguageSelect, LanguageSelectWrapper } from './styles'

type ChangeLanguageProps = {
  trackLanguageChanged?: (any) => Promise<any>
}

const onLanguageChange = (
  newLanguage: SupportedLanguages,
  trackLanguageChanged
) => {
  trackLanguageChanged(newLanguage)
  return i18n.changeLanguage(newLanguage)
}

export const ChangeLanguage: React.SFC<ChangeLanguageProps> = ({
  trackLanguageChanged,
}) => {
  const [options, setOptions] = React.useState([])

  React.useEffect(() => {
    const languageOptions = Object.values(supportedLanguages)
    setOptions(languageOptions)
  }, [])

  return (
    <LanguageSelectWrapper>
      <LanguageSelect
        value={i18n.getCurrentLanguage()}
        renderBeforeContent={() => <GlobeIcon />}
        onChange={(newLanguage: SupportedLanguages) =>
          onLanguageChange(newLanguage, trackLanguageChanged)
        }
        options={options}
      />
    </LanguageSelectWrapper>
  )
}

const mapDispatchToProps = {
  trackLanguageChanged: events.trackLanguageChanged,
}

export default connect(
  null,
  mapDispatchToProps
)(ChangeLanguage)
